<template>
  <v-container style="max-width: 100%">
    <v-data-table
      v-model="selectedApplications"
      :headers="headersApplications"
      :items="applications"
      class="elevation-1 ma-2"
      :items-per-page="-1"
      sort-by="dateTime"
      dense
      :single-select="false"
      :show-select="true"
      :search="searchApplicationTable"
      fixed-header
      height="60vh"
      :disabled="$store.getters.loadingApp === 1"
      :footer-props="{
        'items-per-page-options': [itemsPerPage]
      }"
      @input="reviewSelects($event)"
    >
      <template v-slot:top>
        <div class="d-flex flex-column my-8">
          <div class="d-flex justify-center mt-8">
            <v-radio-group
              v-model="directOrAgencies"
              row
              class="mt-0 mx-4"
              @change="getApplications()"
            >
              <v-radio
                label="Direct Payments"
                value="directClients"
                class="my-0 py-0"
              />
              <v-radio
                label="Payments Agencies"
                value="Agencies"
                class="my-0 py-0"
              />
              <div class="mx-4">
                <v-select
                  v-model="selectedAgency"
                  style="width: 250px"
                  :items="$store.getters.clientAgencies"
                  item-text="organisationName"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="All Agencies"
                  single-line
                  validate-on-blur
                  clearable
                  class="mt-0 pt-0"
                  :disabled="directOrAgencies !== 'Agencies'"
                  @change="getApplications()"
                />
              </div>
              <v-radio
                label="All Applications"
                value="all"
                class="my-0 py-0"
              />
            </v-radio-group>
          </div>
          <div class="d-flex flex-row flex-wrap justify-center mb-2">
            <div>
              <v-radio-group
                v-model="scopeApplications"
                row
                class="mt-0 mx-4"
                :disabled="directOrAgencies === 'all'"
                @change="getApplications()"
              >
                <v-radio
                  label="Ongoing"
                  value="ongoing"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Not Paid"
                  value="notPaid"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Completed"
                  value="completed"
                  class="my-0 py-0"
                />
              </v-radio-group>
            </div>
          </div>
          <div class="d-flex flex-row flex-wrap justify-center">
            <v-card flat>
              <v-text-field
                v-model="searchApplicationTable"
                append-icon="$vuetify.icons.icon_mdi_magnify"
                :label="'Search ' + `${ applications.length }` + ' application(s)'"
                single-line
                hide-details
                style="width: 400px"
                clearable
              />
            </v-card>
            <!-- {{ selectedApplications.length }} -->
            <v-btn
              :disabled="selectedApplications.length < 2"
              class="mx-4 mt-2"
              @click="mergeApplications()"
            >
              Merge Selected    
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.applied`]="{ item }">
        <span v-html="formattedDate(item.applied, 'dateYearShort')" />
      </template>
      <!-- <template v-slot:[`item.id`]="{ item }">
            <v-btn small rounded @click="showApplication(item.id)">{{ item.id }}</v-btn>
        </template> -->
      <template v-slot:[`item.start_first_service`]="{ item }">
        <span v-html="formattedDate(item.start_first_service, 'dateYearShort')" />
      </template>
      <template v-slot:[`item.end_last_service`]="{ item }">
        <span v-html="formattedDate(item.end_last_service, 'dateYearShort')" />
      </template>
      <template v-slot:[`item.totalPrice`]="{ item }">
        <span
          v-if="item.totalPrice"
          v-html="'$' + decUtil.format(decUtil.toDec(item.totalPrice))"
        />
      </template>
      <template v-slot:[`item.open`]="{ item }">
        <span
          v-if="item.open && (item.statusAppId ===16)"
          v-html="'<FONT COLOR=grey><strong>$' + decUtil.format(decUtil.toDec(item.open)) + '</strong>'"
        />
        <span
          v-else-if="item.open"
          v-html="'<FONT COLOR=red><strong>$' + decUtil.format(decUtil.toDec(item.open)) + '</strong>'"
        />
        <span
          v-else
          v-html="'<FONT COLOR=green><strong>PAID</strong>'"
        />
      </template>
      <template v-slot:[`item.statusAppId`]="{ item }">
        <v-chip
          :color="getStatusApp(item.statusAppId).color"
          small
          text-color="white"
          v-html="getStatusApp(item.statusAppId).name"
        />
      </template>
      <template v-slot:[`item.frozen`]="{ item }">
        <v-icon
          v-if="item.frozen === 1"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="grey lighten-2"
              v-bind="attrs"
              fab
              x-small
              :disabled="$store.state.loadingApp > 0"
              v-on="on"
            >
              <v-icon
                small
                @click="$store.dispatch('setLoadingApp', 1), showApplication(item.id)"
              >
                $vuetify.icons.icon_mdi_pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Edit Application</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import getStatusApp from '../mixins/getStatusApp';
import createAppTitle from '../mixins/createAppTitle';
import dayjs from 'dayjs';
import decUtil from '@/utils/decimalUtils';
export default {

  mixins: [inputRules, formattedDate, getStatusApp, createAppTitle],
  data() {
    return {
        decUtil,
      applications: [],
      headersApplications: [
          { text: 'Application', align: 'start', value: 'appTitle', width: '200px' },
        //   { text: 'App.nr.', value: 'id' },
          { text: 'Payer Name', value: 'payerName', width: '150px' },
        //   { text: '#Services', value: 'amountOfServices' },
          { text: 'Applied on', value: 'applied', width: '100px' },
        //   { text: 'Application nr', value: 'id' },
          { text: 'Start', value: 'start_first_service', width: '100px' },
          { text: 'End', value: 'end_last_service', width: '100px' },
          { text: 'Price', value: 'totalPrice' },
        //   { text: 'Deposit', value: 'depositPaid' },
        //   { text: 'Paid', value: 'amountPaidApplication' },
          { text: 'Open', value: 'open' },
          { text: 'Comments', value: 'comments', width: '200px' },
          { text: 'Status', value: 'statusAppId', width: '100px' },
          { text: 'Frozen', value: 'frozen', width: '10px' },
          { text: 'Actions', value: 'actions', sortable: false, width: '80px' },
      ],
        loadingButtonAllApplications: false,
        loadingButtonNotCompleted : false,
        loadingButtonNotPaid: false,
        scopeApplications: 'ongoing',
        directOrAgencies: 'directClients',
        selectedAgency: null,
        selectedApplications: [],
        searchApplicationTable: '',
    }
  },
  computed: {
    loadApplications () {
        return this.$store.getters.loadApplications
    },

    itemsPerPage () {
        return this.$store.getters.itemsPerPage
    },

  },
  
  watch: {
    loadApplications: function () {
      console.log('loadApplications #1');
      if (this.$store.getters.loadApplications) {
        console.log('loadApplications #2', this.$store.getters.loadApplications);
        this.getApplications();
      }
      this.$store.dispatch('loadApplications', false);
    },
  },


  created () {
        dayjs.locale("en");
        this.initialize();
  },

  methods: {
    async initialize () {
      this.$store.dispatch('setLoadingApp', 1)
      this.$store.dispatch('breadcrumbs', ['Applications']);
      await this.$store.dispatch('getOrganisations');
        await this.$store.dispatch('getContacts');
        await this.$store.dispatch('getAvailableAgencies');
      if (this.$store.state.directOrAgencies) {
        this.directOrAgencies = this.$store.state.directOrAgencies;
      }
      if (this.$store.state.scopeApplications) {
        this.scopeApplications = this.$store.state.scopeApplications;
      }
      if (this.$store.state.selectedAgency) {
        this.selectedAgency = this.$store.state.selectedAgency;
      }
      await this.getApplications();
    },

    async getApplications() {
        this.$store.dispatch('setLoadingApp', 1)

        // console.log('this.directOrAgencies', this.directOrAgencies, this.scopeApplications);
        
        if (this.directOrAgencies === 'all') {
            this.applications = await this.$store.dispatch('getAllApplications');
        } else if (this.directOrAgencies === 'directClients') {
            if (this.scopeApplications === 'ongoing') {
                this.applications = await this.$store.dispatch('getApplicationsOngoingDirectServices');
            } else if (this.scopeApplications === 'notPaid') {
                this.applications = await this.$store.dispatch('getApplicationsNotPaidDirectServices');
            } else if (this.scopeApplications === 'completed') {
                this.applications = await this.$store.dispatch('getApplicationsCompletedDirectServices');
            }
        } else {
            var payload = this.selectedAgency;
            if (this.scopeApplications === 'ongoing') {
                this.applications = await this.$store.dispatch('getApplicationsOngoingAgencies', payload);
            } else if (this.scopeApplications === 'notPaid') {
                this.applications = await this.$store.dispatch('getApplicationsNotPaidAgencies', payload);
            } else if (this.scopeApplications === 'completed') {
                this.applications = await this.$store.dispatch('getApplicationsCompletedAgencies', payload);
            }
        }
        this.storeScope();
        this.checkApplications();
        this.$store.dispatch('setLoadingApp', 0)

        // if (event === null) {
        //     this.getApplications()
        // } else {
        //     await this.$store.dispatch('changeScopeApplications', event);
        //     await this.$store.dispatch('changeSelectedAgency', event);
        //     let sqlTxt = 'SELECT * FROM view_applications WHERE payerAgency = '
        //     sqlTxt = sqlTxt.concat(event)
        //     this.applications = await this.$store.dispatch('openQuery', sqlTxt);
        //     this.checkApplications();
        // }
    },

    storeScope() {
        this.$store.dispatch('changeDirectOrAgencies', this.directOrAgencies);
        this.$store.dispatch('changeScopeApplications', this.scopeApplications);
        this.$store.dispatch('changeSelectedAgency', this.selectedAgency);
    },

    checkApplications () {
        if (!this.applications) return;

        this.selectedApplications = [];

        for (const app of this.applications) {

            // determine payer name
            if (app.payerClient !== null) {
                app.payerName = app.payerClientName;
            } else if (app.payerAgency !== null) {
                app.payerName = app.payerAgencyName;
            }

            // normalize numeric values
            if (app.amountPaidApplication == null) app.amountPaidApplication = 0;
            if (app.totalPrice == null) app.totalPrice = 0;

            // normalize comments
            if (app.comments === null) app.comments = '';

            // business rules for selectable
            if (
                app.refund > 0 ||
                app.fixedPrice > 0 ||
                app.discount > 0 ||
                app.extraChargeUSD > 0 ||
                app.comments.trim().length > 0 ||
                app.amountPaidApplication > 0 ||
                app.amountReturnedApplication > 0 ||
                app.statusFixedClient === 8 ||
                app.statusFixedClient === 9
            ) {
                app.isSelectable = false;
            } else {
                app.isSelectable = true;
            }

            // adjust null dates
            if (app.start_first_service === null) app.start_first_service = '';
            if (app.start_last_service === null) app.start_last_service = '';

            // calculate open amount
            app.open = Number(app.totalPrice) - Number(app.amountPaidApplication);
        }
    },

    async showApplication(appId) {
      console.log('showApplication', appId);
      let application = await this.$store.dispatch('getApplicationId', appId);
      await this.$store.dispatch('saveDataForReport', application);
      this.$store.dispatch('showApplication', true);
    },
    
    async reviewSelects(event) {
        console.log('reviewSelects', event);

        let payer = null;

        // determine payer type from selected applications
        for (const app of this.selectedApplications) {
            if (app.payerClient) {
                payer = 'client';
            } else {
                payer = app.payerAgency;
            }
        }

        if (this.selectedApplications.length === 0) payer = null;

        for (const app of this.applications) {

            // payer restriction
            if (payer === 'client') {
                app.isSelectable = !!app.payerClient;
            } else if (payer !== null) {
                app.isSelectable = app.payerAgency === payer;
            } else {
                app.isSelectable = true;
            }

            // normalize comments
            if (app.comments === null) app.comments = '';

            // business rules that forbid selection
            if (
                app.refund > 0 ||
                app.fixedPrice > 0 ||
                app.discount > 0 ||
                app.extraChargeUSD > 0 ||
                app.comments.trim().length > 0 ||
                app.amountPaidApplication > 0 ||
                app.statusFixedClient === 8 ||
                app.statusFixedClient === 9
            ) {
                app.isSelectable = false;
            }
        }
    },

    async mergeApplications() {
        const store = this.$store;

        store.dispatch('progressAdvance', 0);
        store.dispatch('showProgressBar', true);

        const appIdNew = Date.now();
        const oldApplicationIds = [];
        const payload = {
            client: null,
            applications: [],
            services: [],
            radioGroups: null,
            radioOptions: null,
            options: null,
            resources: null
        };

        const step = 99 / this.selectedApplications.length;
        let progress = 1;

        for (const app of this.selectedApplications) {

            const services = await store.dispatch('getServicesAppId', app.id);
            console.log('services', services);

            for (const service of services) {
                payload.services.push({
                    ...service,
                    application_id: appIdNew,
                    start: service.start ? this.formattedDate(service.start, 'date') : null,
                    end: service.end ? this.formattedDate(service.end, 'date') : null
                });
            }

            oldApplicationIds.push(app.id);

            progress += step;
            store.dispatch('progressAdvance', progress);
        }

        let application = this.createNewApplication(appIdNew);

        console.log('application', application, this.selectedApplications);
        
        if (this.selectedApplications.payerClient !== null) {
          application.payerClient = this.selectedApplications.payerClient;
          application.payerClientName = this.selectedApplications.payerClientName;
        } else if (this.selectedApplications.payerAgency !== null) {
          application.payerAgency = this.selectedApplications.payerAgency;
          application.payerAgencyName = this.selectedApplications.payerAgencyName;
        }

        // application.appTitle = await this.createAppTitle(application, null);
        application.applied = application.applied
            ? this.formattedDate(application.applied, 'date')
            : null;

        application.invoice_date = this.formattedDate(store.state.today, 'date');

        payload.applications.push(application);

        store.dispatch('showProgressBar', false);
        store.dispatch('progressAdvance', 0);
        this.$store.dispatch('setLoadingApp', 1)

        let result = await store.dispatch('insertUpdateMainItems', payload);

        // delete old applications after successful merge
        await Promise.all(
            oldApplicationIds.map(id => store.dispatch('deleteApplication', id))
        );
        
        store.dispatch('successMessage', `Applications merged into ${result.data.applications[0].appTitle}`);

        this.getApplications();
        this.showApplication(appIdNew);
    },

    createNewApplication(appIdnew) {
        // console.log('createNewApplication');
        let newApp = {};
        newApp.id = appIdnew;
        newApp.autoAppTitle = true;
        newApp.amountPaidApplication = 0;
        newApp.frozen = false;
        newApp.pass_to_planning = 0;
        newApp.amountOfClients = 1;
        newApp.syncPM = true;
        newApp.fixedPrice = null;
        newApp.totalPrice = null;
        newApp.depositTotal = null;
        newApp.currencyFixed = '$';
        newApp.discount = null;
        newApp.discountPercentage = null;
        newApp.currencyDiscount = '$';
        newApp.refund = null;
        newApp.currencyRefund = '$';
        newApp.exchangeRate = this.$store.state.exchangeRate;
        newApp.comments = null;
        newApp.last_changed_by = this.$store.state.uid;
        newApp.applicationNotPaid = 1;
        newApp.depositPaid = 0;
        return newApp;
    },
    
  }
}
</script>

<style>

/* thead .v-simple-checkbox {
    display: none;
} */

</style>